<script>
    import { t } from 'svelte-i18n';
</script>

<svelte:head>
    <title>{$t(`website.page.termsConditions.meta.title`)}</title>
    <meta name="description" content={$t(`website.page.termsConditions.meta.description`)} />
</svelte:head>

<section class="w-full container max-w-screen-md px-5 mx-auto my-32 mb-16 sm:my-40">
    <div class="flex flex-col">
        <h1>Allgemeine Geschäfts<span class="sm:hidden">-<br /></span>bedingungen</h1>
        <p>
            BSA Corse GmbH
            <br />
            Industriestrasse 30
            <br />
            68519 Viernheim
        </p>
        <h2>I. Vertragsabschluss</h2>
        <ol>
            <li>
                BSA liefert ausschließlich zu diesen Bedingungen. Bedingungen des Auftraggebers wird hiermit
                ausdrücklich widersprochen.
            </li>
            <li>Abweichungen von diesen Bedingungen sind nur wirksam, wenn sie schriftlich vereinbart werden.</li>
            <li>
                Mit der Entgegennahme der Lieferung erkennt der Auftraggeber die Geltung dieser Bedingungen für künftige
                Lieferungen an.
            </li>
        </ol>
        <h2>II. Lieferung und Lieferzeit</h2>
        <ol>
            <li>
                Lieferungen erfolgen grundsätzlich zum vereinbarten Liefertermin. Bei Überschreitung des Liefertermins
                ist der Käufer nur zum Rücktritt vom Vertrag berechtigt, wenn er zuvor eine angemessene Nachfrist zur
                Lieferung gesetzt hat.
            </li>
            <li>Bei Sonderanfertigungen ist der Rücktritt vom Vertrag ausgeschlossen.</li>
            <li>
                Unvorhergesehene Lieferungshindernisse wie Fälle höherer Gewalt, Streiks, Aussperrungen,
                Betriebsstörungen und von BSA Corse GmbH, nicht zu vertretende Nichtbelieferung durch Zulieferer
                verlängern die Lieferzeit um die Dauer der Behinderung.
            </li>
            <li>
                Keine Verpflichtung zur Lieferung besteht im Falle der Nichtverfügbarkeit der Ware. BSA Corse GmbH,
                informiert in diesem Falle den Käufer unverzüglich nach Feststellung der Nichtverfügbarkeit.
            </li>
            <li>
                Schadensersatzansprüche des Käufers wegen verspäteter Lieferung oder Nichterfüllung sind in jedem Fall
                ausgeschlossen.
            </li>
        </ol>
        <h2>III. Versand</h2>
        <ol>
            <li>
                Der Versand erfolgt in allen Fällen auf Rechnung und Gefahr des Käufers. Die Gefahr geht spätestens mit
                der Absendung der Waren auf den Käufer über.
            </li>
            <li>
                Verzögert sich der Versand ohne Verschulden von BSA Corse GmbH, so lagert die Ware auf Kosten und Gefahr
                des Käufers. In diesem Falle steht die Anzeige der Versandbereitschaft dem Versand gleich.
            </li>
            <li>Teillieferungen sind zulässig.</li>
        </ol>
        <h2>IV. Preise und Zahlungen</h2>
        <ol>
            <li>
                In Rechnung gestellt werden die am Tag der Lieferung gültigen Preise. Die angegebenen Preise verstehen
                sich in Euro ab Viernheim zuzüglich der Mehrwertsteuer in der jeweils geltenden gesetzlichen Höhe.
            </li>
            <li>
                Erstkunden werden nur gegen Vorauskasse beliefert. Bei Kunden, die mehr als 1 Jahr keinen Umsatz
                generiert haben, behält sich BSA Corse GmbH das Zurücksetzen auf Vorauskasse vor.
            </li>
            <li>
                Bei Vorgängen ab 10.000,00 € behält sich BSA Corse GmbH die Vereinbarung von abweichenden
                Zahlungsbedingungen, in Form von Teilzahlung im Voraus, vor.
            </li>
            <li>Der Rechnungsbetrag ist sofort und ohne Abzug fällig.</li>
            <li>Bei Abholung der Ware ist der Rechnungsbetrag sofort in bar, EC-Cash oder Kreditkarte zu zahlen.</li>
            <li>Sonderanfertigungen werden ausschließlich gegen Vorkasse bestellt und geliefert.</li>
            <li>
                Die Portokosten richten sich nach Gewicht und Größe und werden spätestens in der Auftragsbestätigung
                aufgeführt.
            </li>
            <li>Die Portokosten werden bei Rückgabe der Ware nicht erstattet.</li>
            <li>
                Im Fall einer Warenrücknahme berechnet BSA Corse GmbH, 10% des Rechnungswarenwertes als
                Wiedereinlagerungskosten für die notwendige Prüfung und lagermäßige Bearbeitung.
            </li>
            <li>
                Für die Lieferungen im Ausland gelten die vereinbarten bzw. die auf den Angeboten oder spätestens auf
                den Auftragsbestätigungen ausgewiesenen Frachtkosten.
            </li>
            <li>Die Zollbestimmungen des jeweiligen Bestimmungsland sind zu akzeptieren.</li>
            <li>
                Zurückbehaltungsrechte und die Aufrechnung des Käufers mit Forderungen gegen BSA Corse GmbH sind
                ausgeschlossen, es sei denn, die geltend gemachten Gegenforderungen sind unbestritten oder rechtskräftig
                festgestellt.
            </li>
            <li>
                Bei Zahlungsverzug werden Verzugszinsen in der jeweils geltenden gesetzlichen Höhe fällig. Die
                Geltendmachung weiteren Verzugsschadens bleibt ausdrücklich vorbehalten.
            </li>
        </ol>
        <h2>V. Widerrufs- und Rückgaberecht</h2>
        <ol>
            <li>
                Bei Vorliegen eines Fernabsatzvertrages ist der Käufer berechtigt, seine Vertragserklärung innerhalb von
                zwei Wochen ohne Angabe von Gründen in Textform oder durch Rücksendung der bereits erhaltenen Ware
                widerrufen. Die Frist beginnt mit Erhalt dieser Belehrung. Der Widerruf ist zu richten an: BSA Corse
                GmbH, Industrie Str. 30, 68519 Viernheim
            </li>
            <li>
                Bei Vorliegen eines Fernabsatzvertrages ist der Käufer berechtigt, die erhaltene Ware innerhalb von zwei
                Wochen ohne Angabe von Gründen zurückzugeben. Nur bei nicht paketversandfähiger Ware kann die Rückgabe
                auch durch Rücknahmeverlangen in Textform erklärt werden. Die Frist beginnt mit Erhalt dieser Belehrung.
                Die Rücksendung oder das Rücknahmeverlangen hat zu erfolgen an: BSA Corse GmbH, Industrie Str. 30, 68519
                Viernheim
            </li>
            <li>
                Im Falle eines wirksamen Widerrufs sind die beiderseits empfangenen Leistungen zurückzugewähren und
                gegebenenfalls gezogene Nutzungen herauszugeben. Der Käufer ist zudem verpflichtet, Wertersatz zu
                leisten, wenn die empfangene Ware ganz oder teilweise nicht oder nur in verschlechtertem Zustand
                zurückgegeben wird.
            </li>
            <li>
                Das Widerrufs- und Rückgaberecht ist ausgeschlossen bei gebrauchten Waren oder Waren, die nach
                Kundenspezifikation gesondert gefertigt wurden.
            </li>
        </ol>
        <h2>VI. Eigentumsvorbehalt</h2>
        <ol>
            <li>
                Das Eigentum an allen Lieferungen wird bis zur vollständigen Erfüllung aller Ansprüche aus der
                Geschäftsverbindung vorbehalten. Dies gilt auch dann, wenn der Kaufpreis für bestimmte vom Käufer
                bezeichnete Warenlieferungen bezahlt ist oder die Ware weiterverkauft wurde. Infolgedessen ist bis zur
                Erfüllung sämtlicher BSA Corse GmbH, gegenüber dem Käufer zustehenden Ansprüchen die Verpfändung oder
                Sicherungsübereignung der gelieferten Waren unzulässig.
            </li>
            <li>Bei laufender Rechnung gilt das vorbehaltene Eigentum als Sicherung für unsere Saldoforderung.</li>
            <li>
                Wird die von BSA gelieferte Ware mit anderen Gegenständen vermischt oder verbunden, so tritt der Käufer
                hierdurch sein Eigentums- bzw. Miteigentumsrecht an dem vermischten Bestand oder an dem neuen Gegenstand
                an uns ab.
            </li>
            <li>
                Der Käufer darf die gelieferte Ware und die aus der Bearbeitung oder Verarbeitung entstehenden Sachen
                nur im regelmäßigen Geschäftsverkehr veräußern. Er tritt hiermit die für ihn aus der Veräußerung oder
                aus einem sonstigen Rechtsgrunde hinsichtlich der von BSA Corse GmbH gelieferten oder aufgrund dieser
                Bedingungen in sein Eigentum gelangten Waren entstandenen Forderungen gegen seine Abnehmer mit ihrer
                Entstehung in voller Höhe sicherheitshalber mit dinglicher Wirkung mit allen Nebenrechten im voraus an
                uns ab. Infolgedessen ist bis zur Erfüllung sämtlicher BSA Corse GmbH gegenüber dem Käufer zustehenden
                Ansprüche die Verpfändung oder Abtretung von Forderungen, insbesondere an Finanzierungsinstitute, ohne
                die schriftliche Zustimmung von BSA Corse GmbH unzulässig.
            </li>
            <li>
                Der Käufer ist zur Einziehung der abgetretenen Forderungen ermächtigt, solange er seinen
                Zahlungsverpflichtungen BSA Corse GmbH gegenüber ordnungsgemäß nachkommt. Geschieht dies nicht, ist BSA
                berechtigt, die Abtretung offen zu legen.
            </li>
        </ol>
        <h2>VII. Gewährleistung</h2>
        <ol>
            <li>
                Erkennbare Mängel sind unverzüglich und sofort nach Erhalt der Ware, BSA schriftlich anzuzeigen. Im
                Übrigen gelten die gesetzlichen Gewährleistungsfristen.
            </li>
            <li>
                Gewährleistungsansprüche sind zunächst beschränkt auf Nachbesserung oder Ersatzlieferung nach Wahl von
                BSA. Bei Unmöglichkeit oder Erfolglosigkeit von Nachbesserung oder Ersatzlieferung ist der Käufer
                berechtigt, vom Vertrag zurückzutreten.
            </li>
            <li>
                Weitergehende Gewährleistungsansprüche können gegenüber BSA nur bei Vorsatz oder grober Fahrlässigkeit
                geltend gemacht werden.
            </li>
            <li>
                Sämtliche Ersatz- und Gewährleistungsansprüche erlöschen, wenn von BSA gelieferte Ware bei
                Motorsporteinsätzen jeglicher Art verwendet, anderweitig verändert oder Instand gesetzt werden bzw.
                eigenmächtig vorgenommene Eingriffe an der Ware vorgenommen wurden.
            </li>
        </ol>
        <h2>VIII. Einbau- und Montageanleitung</h2>
        <ol>
            <li>
                BSA wendet sich mit den angebotenen Produkten an Spezialisten aus dem Kraftfahrzeug- und
                Motorsportbereich. Diese Produkte enthalten üblicherweise keine Einbau- oder Montageanleitung, da deren
                Einbau oder Montage zur Vermeidung missbräuchlicher oder fehlerhafter Verwendung diese Produkte nur von
                Fachleuten bzw. in Fachwerkstätten vorgenommen werden darf.
            </li>
        </ol>
        <h2>IX. Verwendung im öffentlichen Straßenverkehr</h2>
        <ol>
            <li>
                Für Zulassungen zum Betrieb im öffentlichen Straßenverkehr sind ausschließlich die zu dem jeweiligen
                Produkt gehörende ABE bzw. das TÜV-Gutachten und die darin eventuell enthaltenen Auflagen maßgeblich.
                Die für den Motorsport hergestellten und angebotenen Waren besitzen – sofern nicht ausdrücklich anderes
                angegeben ist – keine Zulassung für die Verwendung im öffentlichen Straßenverkehr.
            </li>
        </ol>
        <h2>X. Haftung aus anderen Rechtsgründen</h2>
        <ol>
            <li>
                Die Haftung für leicht fahrlässige Pflichtverletzungen ist ausgeschlossen, sofern diese keine
                vertragswesentlichen Pflichten, Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit
                oder Garantien betreffen oder Ansprüche gemäß dem Produkthaftungsgesetz berührt sind. Dies gilt auch für
                Pflichtverletzungen durch unsere Erfüllungsgehilfen.
            </li>
        </ol>
        <h2>XI. Schlussbestimmungen</h2>
        <ol>
            <li>
                Erfüllungsort für die beiderseitigen Vertragsverpflichtungen sowie ausschließlicher Gerichtsstand für
                alle aus dem Vertragsverhältnis resultierenden Streitigkeiten ist Weinheim.
            </li>
            <li>
                Für diese Geschäftsbedingungen und die gesamten Rechtsbeziehungen zwischen dem Kunden und BSA gilt das
                Recht der Bundesrepublik Deutschland.
            </li>
            <li>
                Bei internationalen Kaufverträgen ist die Anwendung des einheitlichen internationalen Kaufrechts
                ausgeschlossen.
            </li>
        </ol>
    </div>
</section>

<style>
    h1 {
        @apply mb-4 text-3xl font-semibold text-primary uppercase;
    }

    h2 {
        @apply mt-8 mb-3 text-xl text-secondary;
    }

    li {
        @apply mb-3;
    }
</style>
